// Core
import React, { useState } from "react";

// Components - Contrib
import { Container, Row, Col, Card, Button } from "react-bootstrap";

// Components - Custom
import "./App.css";
//import { questions, answers } from "./data/humanSubjects";
import { questions, answers } from "./data/clinicalTrial";
//import { questions, answers } from "./data/multiPolicy";
import Question from "./components/question";
import Answer from "./components/answer";

function App() {
	// Defining the inital state of the Decision Making Tool (dmt) for later reset.
	const initialTarget = questions.find((q) => q.id === "q-1");

	// Saving initial Card into state to keep track of steps
	const [dmt_history, setDmt_history] = useState([initialTarget]);

	// Target
	const [target, setTarget] = useState("");

	const handleGoBack = () => {
		const newHistory = [...dmt_history];
		newHistory.pop();
		setDmt_history(newHistory);
	};

	const handleGoFurther = () => {
		const newHistory =
			target.charAt(0) === "q" ? questions.find((q) => q.id === target) : answers.find((q) => q.id === target);
		setDmt_history([...dmt_history, newHistory]);
		setTarget("");
	};

	const handleStartOver = () => {
		setDmt_history([initialTarget]);
	};

	return (
		<Container fluid className="p-0">
			<Row>
				<Col>
					<Card>
						<Card.Header>
							{dmt_history[dmt_history.length - 1].id.charAt(0) === "q" ? (
								<h3>Question {dmt_history.length}</h3>
							) : (
								<h3>Result</h3>
							)}
						</Card.Header>
						<Card.Body>
							{dmt_history[dmt_history.length - 1].id.charAt(0) === "q" ? (
								<Question data={dmt_history[dmt_history.length - 1]} newTarget={setTarget} />
							) : (
								<Answer data={dmt_history[dmt_history.length - 1]} />
							)}
						</Card.Body>
						<Card.Footer>
							<div className="flexedBetween">
								<div>
									<Button
										variant="primary"
										style={{ display: dmt_history.length > 1 ? "block" : "none" }}
										onClick={handleGoBack}>
										Back
									</Button>
								</div>
								<div>
									<Button variant="primary" onClick={handleGoFurther} disabled={target === "" ? true : false}>
										Next
									</Button>
									<Button
										variant="primary"
										style={{
											marginLeft: "10px",
											display:
												dmt_history[dmt_history.length - 1].id.charAt(0) === "r" ? "inline-block" : "none",
										}}
										onClick={handleStartOver}>
										Start Over
									</Button>
								</div>
							</div>
						</Card.Footer>
					</Card>
				</Col>
			</Row>
		</Container>
	);
}

export default App;
